import React from 'react';
import { useGesture } from 'react-use-gesture';
import { Image } from "../style";
import { ZoomWrapper, ZoomContainer, ZoomButton } from "../../zoom";
import { PopoutImageContainer } from '../style';
import { Magnetic as Mi } from "../../../styles";
export const PopoutImageZoomedView = (props) => {
    const domTarget = React.useRef(null);
    const imageRef = React.useRef(null);
    const [offsetX, setOffsetX] = React.useState(0);
    const [offsetY, setOffsetY] = React.useState(0);
    const [imageWidth, setImageWidth] = React.useState(0);
    const [imageHeight, setImageHeight] = React.useState(0);
    const [panOffset, setPanOffset] = React.useState([0, 0]);
    const [currentZoomScale, setCurrentZoomScale] = React.useState(1);
    const [isDoubleClickDisabled, setIsDoubleClickDisabled] = React.useState(false);
    const [isPanning, setIsPanning] = React.useState(false);
    const [mouseDownCoords, setMouseDownCoords] = React.useState([0, 0]);
    const { file, index, zoomScale, setZoomScale } = props.carouselViewProps;
    const getEarmarkStyle = (carouselItem) => {
        return carouselItem.tagId ? { paddingTop: `${Mi.spacer48}` } : undefined;
    };
    const getCursor = () => {
        return zoomScale > 1 ? { cursor: 'grab' } : { cursor: 'default' };
    };
    const gestureHandler = useGesture({
        onWheel: ({ movement }) => {
            movement[1] < 0 ? handleZoom(0.25) : handleZoom(-0.25);
        }
    }, { domTarget });
    React.useEffect(gestureHandler, [gestureHandler]);
    React.useEffect(() => {
        if (zoomScale == 1)
            resetZoom();
        else
            setCurrentZoomScale(zoomScale);
    }, [zoomScale]);
    React.useEffect(() => {
        if (imageRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            setImageWidth(rect.width);
            setImageHeight(rect.height);
        }
    }, [zoomScale, imageRef]);
    const onClickHandler = event => {
        setIsDoubleClickDisabled(false);
    };
    const onDoubleClickHandler = event => {
        !isDoubleClickDisabled && resetZoom();
    };
    const handleOnKeyDownEvent = (event) => {
        switch (event.key) {
            case 'ArrowUp':
                handleZoom(0.25);
                break;
            case 'ArrowDown':
                handleZoom(-0.25);
                break;
            default:
                break;
        }
    };
    const onMouseDownHandler = event => {
        setMouseDownCoords([event.clientX, event.clientY]);
        setIsPanning(true);
    };
    const onMouseMoveHandler = event => {
        if (!isPanning)
            return;
        const dx = panOffset[0] + event.clientX - mouseDownCoords[0];
        const dy = panOffset[1] + event.clientY - mouseDownCoords[1];
        const newOffset = getConstrainedPanOffsets(dx, dy);
        setOffsetX(newOffset[0]);
        setOffsetY(newOffset[1]);
    };
    const onMouseUpHandler = event => {
        setPanOffset([offsetX, offsetY]);
        setIsPanning(false);
    };
    const onZoomInHandler = event => {
        event.stopPropagation();
        setIsDoubleClickDisabled(true);
        handleZoom(0.25);
    };
    const onZoomOutHandler = event => {
        event.stopPropagation();
        setIsDoubleClickDisabled(true);
        handleZoom(-0.25);
    };
    const handleZoom = (dZoom) => {
        const newZoom = Math.max(Math.min(zoomScale + dZoom, 4), 1);
        setZoomOffsets(newZoom / currentZoomScale);
        setZoomScale(newZoom);
    };
    const getConstrainedPanOffsets = (dx, dy) => {
        const maxOffsetX = (imageWidth * zoomScale - imageWidth) / 2 / zoomScale;
        const maxOffsetY = (imageHeight * zoomScale - imageHeight) / 2 / zoomScale;
        return [
            Math.max(Math.min(dx, maxOffsetX), -maxOffsetX),
            Math.max(Math.min(dy, maxOffsetY), -maxOffsetY)
        ];
    };
    const setZoomOffsets = (dZoom) => {
        const dx = offsetX * dZoom;
        const dy = offsetY * dZoom;
        const newOffset = getConstrainedPanOffsets(dx, dy);
        setOffsetX(newOffset[0]);
        setOffsetY(newOffset[1]);
        setPanOffset([newOffset[0], newOffset[1]]);
    };
    const resetZoom = () => {
        setOffsetX(0);
        setOffsetY(0);
        setPanOffset([0, 0]);
        setZoomScale(1);
        setCurrentZoomScale(1);
    };
    return (React.createElement(PopoutImageContainer, { ref: domTarget, id: `image-container-${index}`, onClick: event => onClickHandler(event), onDoubleClick: event => onDoubleClickHandler(event), onMouseDown: event => onMouseDownHandler(event), onMouseMove: event => onMouseMoveHandler(event), onMouseUp: event => onMouseUpHandler(event), onMouseLeave: event => onMouseUpHandler(event), onKeyDown: event => handleOnKeyDownEvent(event), style: getCursor(), tabIndex: 0 },
        React.createElement(ZoomWrapper, { id: `zoom-wrapper-${index}`, scale: zoomScale, onZoomChange: setZoomScale, showZoomIcon: false, gestureEnabled: false, panOffset: [offsetX, offsetY] },
            React.createElement(Image, { ref: imageRef, id: `original-image-${index}`, src: file.url })),
        React.createElement(ZoomContainer, { id: `zoom-container-${index}`, style: getEarmarkStyle(file) },
            React.createElement(ZoomButton, { className: "mi-icon-zoom-in", onClick: event => onZoomInHandler(event), disabled: false }),
            React.createElement(ZoomButton, { className: "mi-icon-zoom-out", onClick: event => onZoomOutHandler(event), disabled: false }))));
};
//# sourceMappingURL=PopoutImageZoomedView.js.map